<template>
    <div id="legs">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initLegs} from 'utils/initPageData'

export default { 
    name: 'Legs',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],
            index: [],
            page1: [
                [
                    ['RTE \xa0 \xa0 \xa0 LEGS',['showIndex','','']],
                    [1,1]
                ], 
                [
                    [ '', '' ], 
                    [ '−−−−−', '' ] 
                ], 
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '',  ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', 'RNP/ACTUAL−−−−−−−−−−−−−−−−−−−−−−−' ], 
                    [ '1.00/0.06NM', '' ] 
                ],
            ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initLegs(this)
    }
}
</script>

<style scoped>

</style>